export function formatDateWithTimeFromBackend(dateWithTimeFromBackend: string | null | undefined) {
    if (!dateWithTimeFromBackend) {
        return null
    }

    const [datePart, timePart] = dateWithTimeFromBackend.split(' ')
        
    if (!datePart || !timePart) {
        return dateWithTimeFromBackend
    }
    
    const [year, month, day] = datePart.split('-')
    return `${day}.${month}.${year} ${timePart}`
}

export function formatDateFromBackend(dateFromBackend: string | null | undefined) {
    if (!dateFromBackend) {
        return null
    }

    const date = new Date(dateFromBackend + 'T00:00:00')

    if (isNaN(date.getTime())) {
        return dateFromBackend
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}.${month}.${year}`
}

export function formatDateTime(value: string | null): string | null {
    if (!value) return null

    const date = new Date(value)
    if (isNaN(date.getTime())) return null

    const pad = (n: number) => String(n).padStart(2, '0')

    const day = pad(date.getDate())
    const month = pad(date.getMonth() + 1)
    const year = date.getFullYear()

    const hours = pad(date.getHours())
    const minutes = pad(date.getMinutes())
    const seconds = pad(date.getSeconds())

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
}